//@/utils/auth.ts
//认证函数

import api from './axios';

// 登录
export const login = async (username: string, password: string) => {
  const response = await api.post('/login/', {
    params: {
      username,
      password
    }
  });
  
  return response.data;
};

// 刷新token
export const refreshToken = async () => {
  const response = await api.post('/refreshtoken/');
  return response.data;
};

// 注销
export const logout = async () => {

  try {
    await api.post('/logout/');
  } catch (error) {
    console.error('注销请求失败:', error);
  } finally {
    // 清除相关状态
    localStorage.removeItem('userNickname');
    localStorage.removeItem('userSerialId');
    localStorage.removeItem('userAvatar');
  }
};

// 检查是否登录
export const isLoggedIn = async () => {
  try {
    const res = await api.get('/checklogin/');
    return res.data.is_login;
  } catch (error) {
    console.error('验证登录状态失败:', error);
    return false; // 出错时默认视为未登录
  }
};

// 定时检查服务器中的refreshToken 不允许用户多端登录
export const getRefreshToken = async () => {
  try {
    const res = await api.get('/getrefreshtoken/');
    return res.data.refreshToken;
  } catch (error) {
    console.error('验证刷新令牌状态失败:', error);
    return false;
  }
};